import { method } from "@/common/common.js"
import loading from "@/assets/commonImage/loading.gif"

export default {
    props: {
        src: {
            type: String,
            default: "",
        },
        fit: {
            type: String,
            default: "cover",
        }
    },
    data() {
        return {
            show: false,
            loading,
            method,
        }
    },
    methods: {

    },
    mounted() {
        this.show = false;
        let imgArr = [];
        imgArr.push(method.setImageBedPath(this.src));
        method.loadImageEnd(imgArr, () => {
            this.show = true;
        });
    }
}